export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_TEKAY_complete_3.98f96c0a.jpg";